<script>
import "./assets/css/reset.min.css"
import "./assets/js/rem"
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import Header2 from "./components/header2.vue"
export default {
    name: 'app',
    components: {
        Header,
        Footer,
        Header2
    },
    mounted() {
        if(localStorage.getItem('token')){
            this.$store.dispatch('getUserinfo');
        }
    },
}
</script>

<template>
    <div id="app">
        <Header2 v-if="$route.path == '/mine/supportDesk'"/>
        <Header v-else/>
        <router-view></router-view>
        <Footer/>
    </div>
</template>


<style lang="scss">
@font-face {
    font-family: 'objectivity';
    src: url('~@/assets/font/objectivity-light-6.otf') format("opentype");
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'objectivity';
    src: url('~@/assets/font/Objectivity-Regular.otf') format("opentype");
    font-weight: 300;
    font-style: normal;
}
@font-face {
    font-family: 'objectivity';
    src: url('~@/assets/font/objectivity-medium-8.otf') format("opentype");
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'objectivity';
    src: url('~@/assets/font/objectivity-bold-4.otf') format("opentype");
    font-weight: bold;
    font-style: normal;
}
:root{
    --color: #333;
    --color-blue: #00ccff;
    --background-color: #1d1d36;
}
#app{
    color: var(--color);
    font-size: .3rem;
    font-family: 'objectivity';
    font-weight: 300;
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.layout_main{
    width: 12rem;
    margin: 0 auto;
    @media only screen and (max-width: 750px) {
        width: 6.9rem;
    }
}
.layout_bg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.position_100{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.position_center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &.left{
        left: 0;
        transform: translate(0, -50%);
    }
}
.flex_center{
    display: flex;
    justify-content: center;
    align-items: center;
}
.flex{
    display: flex;
}
.flex_wrap{
    flex-wrap: wrap;
}
.flex_column{
    flex-direction: column;
}
.justify_center{
    justify-content: center;
}
.justify_between{
    justify-content: space-between;
}
.justify_evenly{
    justify-content: space-evenly;
}
.justify_end{
    justify-content: flex-end;
}
.align_center{
    align-items: center;
}
.align_start{
    align-items: start;
}
.align_end{
    align-items: end;
}
.flex_shrink_0{
    flex-shrink: 0;
}
.flex_grow_1{
    flex-grow: 1;
}
input,
textarea{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    display: block;
    background: none;
    outline: none;
    resize: none;
    color: var(--font_color);
    font-family: 'objectivity';
}
textarea{
    line-height: 1.2;
}

.layout_table{
    width: 100%;
    background: #fff;
    border: 2px solid #dcdcdc;
    border-radius: .05rem;
    font-size: .24rem;
    color: #666;
    .thead{
        font-weight: 600;
        border-bottom: 1px solid #dcdcdc;
    }
    .tr{
        display: flex;
        border-bottom: 1px solid #dcdcdc;
        &:last-child{
            border-bottom: none;
        }
        .td{
            flex: 1;
            padding: .2rem .4rem;
            border-right: 1px solid #dcdcdc;
            display: flex;
            flex-direction: column;
            justify-content: center;
            @media only screen and (max-width: 750px) {
                padding: .2rem;
            }
            &:last-child{
                border-right: none;
            }
        }
    }
}
</style>
